import store from '../store/index.js'
const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const value = modulesFiles(modulePath)
  let nameApis = value.default
  // 函数柯里化
  const filePathMatch = modulePath.match(/\.\/([A-Za-z]+)\//)
  let filePath = filePathMatch ? '/' + filePathMatch[1] : ''
  Object.keys(nameApis).forEach((apiConfig) => {
    let tempFn = nameApis[apiConfig]
    nameApis[apiConfig] = null
    nameApis[apiConfig] = function() {
      store.commit('SET_MODULE', filePath)
      return tempFn(...arguments)
    }
  })
  Object.assign(modules, nameApis)
  // Object.assign(modules, value.default)
  return modules
}, {})
export default modules



// WEBPACK FOOTER //
// ./src/api/index.js